/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  ActivatePhysicalCardRequest,
  CardPaymentMethodType,
  CardVisualizationDetailsResponse,
  DataResponseListPaymentMethodCountryResponse,
  ErrorResponse,
  GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetParams,
  GetPaymentMethodsPaymentMethodsGetParams,
  HTTPValidationError,
  PaymentMethodUIItem,
  PaymentProvider,
  PhysicalCardType,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get Payment Methods
 */
export const getPaymentMethodsPaymentMethodsGet = (
  params?: GetPaymentMethodsPaymentMethodsGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListPaymentMethodCountryResponse>(
    { url: `/payment-methods`, method: "GET", params, signal },
    options
  );
};

export const getGetPaymentMethodsPaymentMethodsGetQueryKey = (
  params?: GetPaymentMethodsPaymentMethodsGetParams
) => {
  return [`/payment-methods`, ...(params ? [params] : [])] as const;
};

export const getGetPaymentMethodsPaymentMethodsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetPaymentMethodsPaymentMethodsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPaymentMethodsPaymentMethodsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>
  > = ({ signal }) =>
    getPaymentMethodsPaymentMethodsGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentMethodsPaymentMethodsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>
>;
export type GetPaymentMethodsPaymentMethodsGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetPaymentMethodsPaymentMethodsGet<
  TData = Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: undefined | GetPaymentMethodsPaymentMethodsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethodsPaymentMethodsGet<
  TData = Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetPaymentMethodsPaymentMethodsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
          TError,
          Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethodsPaymentMethodsGet<
  TData = Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetPaymentMethodsPaymentMethodsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Payment Methods
 */

export function useGetPaymentMethodsPaymentMethodsGet<
  TData = Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetPaymentMethodsPaymentMethodsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsPaymentMethodsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPaymentMethodsPaymentMethodsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Payment methods the participant may create, from PPS for their country
 * intersected with the methods enabled for their study country.
 *
 * Each item is the PPS method plus three PASS fields: `legal_documents` the
 * participant must accept before creating it, `description` (lead text and
 * items localized from `Accept-Language`) and `allowed_payable_types`, the
 * Payable Item kinds an account of that type can receive (Stripe Stipend
 * Cards `stipend` and `micropayment` only, Stripe Spend Cards nothing, every
 * other method all four). There is no filter parameter; the participant app
 * partitions the list client side, for example to offer only claim-capable
 * methods when the current Default Payment Account cannot receive claims.
 * @summary Get Payment Methods From Pps
 */
export const getPaymentMethodsFromPpsPaymentMethodsUiGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<PaymentMethodUIItem[]>(
    { url: `/payment-methods/ui`, method: "GET", signal },
    options
  );
};

export const getGetPaymentMethodsFromPpsPaymentMethodsUiGetQueryKey = () => {
  return [`/payment-methods/ui`] as const;
};

export const getGetPaymentMethodsFromPpsPaymentMethodsUiGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
  >,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPaymentMethodsFromPpsPaymentMethodsUiGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>>
  > = ({ signal }) =>
    getPaymentMethodsFromPpsPaymentMethodsUiGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentMethodsFromPpsPaymentMethodsUiGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>>
  >;
export type GetPaymentMethodsFromPpsPaymentMethodsUiGetQueryError =
  ErrorType<ErrorResponse>;

export function useGetPaymentMethodsFromPpsPaymentMethodsUiGet<
  TData = Awaited<
    ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
  >,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethodsFromPpsPaymentMethodsUiGet<
  TData = Awaited<
    ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
  >,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethodsFromPpsPaymentMethodsUiGet<
  TData = Awaited<
    ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
  >,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Payment Methods From Pps
 */

export function useGetPaymentMethodsFromPpsPaymentMethodsUiGet<
  TData = Awaited<
    ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>
  >,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethodsFromPpsPaymentMethodsUiGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetPaymentMethodsFromPpsPaymentMethodsUiGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Credentials for rendering a card's sensitive details in the participant app.
 *
 * For Stripe the response `signature` is a 15-minute Issuing Elements ephemeral
 * key secret bound to `nonce`; the client should refresh it by calling again.
 * @summary Get Card Visualization Details
 */
export const getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet =
  (
    paymentMethodType: CardPaymentMethodType,
    provider: PaymentProvider,
    params?: GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetParams,
    options?: SecondParameter<typeof nmibleInstanceV3>,
    signal?: AbortSignal
  ) => {
    return nmibleInstanceV3<CardVisualizationDetailsResponse | null>(
      {
        url: `/payment-methods/${paymentMethodType}/${provider}/visualization-details`,
        method: "GET",
        params,
        signal,
      },
      options
    );
  };

export const getGetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetQueryKey =
  (
    paymentMethodType: CardPaymentMethodType,
    provider: PaymentProvider,
    params?: GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetParams
  ) => {
    return [
      `/payment-methods/${paymentMethodType}/${provider}/visualization-details`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
      >
    >,
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
  >(
    paymentMethodType: CardPaymentMethodType,
    provider: PaymentProvider,
    params?: GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetQueryKey(
        paymentMethodType,
        provider,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
        >
      >
    > = ({ signal }) =>
      getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet(
        paymentMethodType,
        provider,
        params,
        requestOptions,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled:
        paymentMethodType !== null &&
        paymentMethodType !== undefined &&
        provider !== null &&
        provider !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
      >
    >
  >;
export type GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetQueryError =
  ErrorType<ErrorResponse | HTTPValidationError>;

export function useGetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet<
  TData = Awaited<
    ReturnType<
      typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
    >
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  paymentMethodType: CardPaymentMethodType,
  provider: PaymentProvider,
  params:
    | undefined
    | GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet<
  TData = Awaited<
    ReturnType<
      typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
    >
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  paymentMethodType: CardPaymentMethodType,
  provider: PaymentProvider,
  params?: GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet<
  TData = Awaited<
    ReturnType<
      typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
    >
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  paymentMethodType: CardPaymentMethodType,
  provider: PaymentProvider,
  params?: GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Card Visualization Details
 */

export function useGetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet<
  TData = Awaited<
    ReturnType<
      typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
    >
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  paymentMethodType: CardPaymentMethodType,
  provider: PaymentProvider,
  params?: GetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetCardVisualizationDetailsPaymentMethodsPaymentMethodTypeProviderVisualizationDetailsGetQueryOptions(
      paymentMethodType,
      provider,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Activate a shipped physical card with its last four digits.
 *
 * Accepts every physical Card Type, Highnote `pc` and `pec` and Stripe `pstc`
 * and `pspc`; virtual types are rejected with 422. PASS calls PPS's single
 * per-card-type activation route, `/v3/payment-methods/cards/{card_type}/activate`,
 * which resolves the provider from its own records, so the participant app
 * never needs to know how PPS routes activation internally.
 * @summary Activate Physical Card
 */
export const activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost =
  (
    paymentMethodType: PhysicalCardType,
    provider: PaymentProvider,
    activatePhysicalCardRequest: BodyType<ActivatePhysicalCardRequest>,
    options?: SecondParameter<typeof nmibleInstanceV3>,
    signal?: AbortSignal
  ) => {
    return nmibleInstanceV3<void>(
      {
        url: `/payment-methods/${paymentMethodType}/${provider}/activate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: activatePhysicalCardRequest,
        signal,
      },
      options
    );
  };

export const getActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationKey =
  () =>
    [
      "activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost",
    ] as const;

export const getActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost
        >
      >,
      TError,
      ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost
      >
    >,
    TError,
    ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost
        >
      >,
      ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationVariables
    > = (props) => {
      const { paymentMethodType, provider, data } = props ?? {};

      return activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost(
        paymentMethodType,
        provider,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost
      >
    >
  >;
export type ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationBody =
  BodyType<ActivatePhysicalCardRequest>;
export type ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationVariables {
  paymentMethodType: PhysicalCardType;
  provider: PaymentProvider;
  data: BodyType<ActivatePhysicalCardRequest>;
}

/**
 * @summary Activate Physical Card
 */
export const useActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost =
  <TError = ErrorType<ErrorResponse | HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost
          >
        >,
        TError,
        ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof activatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePost
      >
    >,
    TError,
    ActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationVariables,
    TContext
  > => {
    return useMutation(
      getActivatePhysicalCardPaymentMethodsPaymentMethodTypeProviderActivatePostMutationOptions(
        options
      ),
      queryClient
    );
  };
